<template>
    <div class="bg-bottom">
        <div class="bottom">
            <div class="menu-con">
                <div class="item">
                    <div class="l-con">
                        <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs1/icon@2x2331.png" />
                    </div>
                    <div class="r-con">
                        <div class="word">{{data?data["d_num"]:"2000"}}</div>
                        <div class="option">下载</div>
                    </div>
                </div>
                <div class="item">
                    <div class="l-con">
                        <img src="https://www.bestkids.net/wechat-miniprogram-static/%E8%83%8C%E6%99%AF%E5%9B%BE/template1/imgs1/icon@2x33.png" />
                    </div>
                    <div class="r-con">
                        <div class="word">{{data?data["u_num"]:"20k"}}</div>
                        <div class="option">用户</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:{
        data:{
            type:Object,
            default:{}
        }
    }
}
</script>
<style scoped lang="scss">
    .bg-bottom{
        width: 100%;
        height: 306px;
        background: rgba(120, 27, 255, 0.03);
    }
     .bottom{
        display: flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        width: 1200px;
        height: 306px;
        margin:0 auto 0;
        .menu-con{
            display: flex;
            align-items: center;
            gap:159px;
            .item{
                display: flex;
                gap:28px;
                .l-con{
                    img{
                        width: 52px;
                        height: 57px;
                    }
                }
                .r-con{
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    .word{
                        font-size: 57px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #000B33;
                        line-height: 68px;
                    }
                    .option{
                        font-size: 15px;
                        font-family: PingFangSC-Regular, PingFang SC;
                        font-weight: 400;
                        color: #000B33;
                        line-height: 23px;
                    }
                }
            }
        }
    }
</style>